
import { defineComponent, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import store from '@/store'
import { userService } from '@/services/User.service'
import TheHeader from '@/components/Shared/TheHeader.vue'
import TheFooter from '@/components/Shared/TheFooter.vue'

export default defineComponent({
  components: {
    TheHeader,
    TheFooter
  },
  props: {
    headerSubtitle: { type: String, default: '' }
  },
  setup() {
    const router = useRouter()

    const { useActions } = createNamespacedHelpers('shared')
    const { fetchAppVersion } = useActions(['fetchAppVersion'])

    onMounted(() => {
      fetchAppVersion()

      // In development there is no Cognito login, so pull the seeded local
      // user's permission map to drive the permission-aware UI. In production
      // the map arrives with the login response instead.
      if (process.env.VUE_APP_AUTH_DISABLED === 'true') {
        store.dispatch('auth/loadCurrentUser').catch(() => undefined)
      }
    })

    const logOutHandler = async () => {
      await userService.logout()
      if (process.env.VUE_APP_COGNITO_LOGOUT_URL) return
      await router.push({ name: 'login' })
    }
    return { logOutHandler, store }
  }
})
